const NVBUGS_DIALOG = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog'

const UPDATE_OTHER_PROJECT = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/UPDATE_OTHER_PROJECT'
const UPDATE_OTHER_PROJECT_LIST = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/UPDATE_OTHER_PROJECT_LIST'
const UPDATE_REC_PROJECT_LIST = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/UPDATE_REC_PROJECT_LIST'
const UPDATE_OPTION_SELECTED = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/UPDATE_OPTION_SELECTED'

const UPDATE_NVBUGS_ID = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/UPDATE_NVBUGS_ID'
const UPDATE_PAGE = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/UPDATE_PAGE'

const FETCH_OTHER_PROJECT_LIST = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_OTHER_PROJECT_LIST'
const FETCH_OTHER_PROJECT_LIST_START = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_OTHER_PROJECT_LIST_START'
const FETCH_OTHER_PROJECT_LIST_SUCCESS = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_OTHER_PROJECT_LIST_SUCCESS'
const FETCH_OTHER_PROJECT_LIST_ERROR = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_OTHER_PROJECT_LIST_ERROR'

const FETCH_REC_PROJECT_LIST = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_REC_PROJECT_LIST'
const FETCH_REC_PROJECT_LIST_START = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_REC_PROJECT_LIST_START'
const FETCH_REC_PROJECT_LIST_SUCCESS = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_REC_PROJECT_LIST_SUCCESS'
const FETCH_REC_PROJECT_LIST_ERROR = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_REC_PROJECT_LIST_ERROR'

const POST_NVBUG_PROJECT = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/POST_NVBUG_PROJECT'
const POST_NVBUG_PROJECT_START = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/POST_NVBUG_PROJECT_START'
const POST_NVBUG_PROJECT_SUCCESS = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/POST_NVBUG_PROJECT_SUCCESS'
const POST_NVBUG_PROJECT_ERROR = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/POST_NVBUG_PROJECT_ERROR'

const FETCH_NVBUG = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_NVBUG'
const FETCH_NVBUG_START = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_NVBUG_START'
const FETCH_NVBUG_SUCCESS = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_NVBUG_SUCCESS'
const FETCH_NVBUG_ERROR = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/FETCH_NVBUG_ERROR'

const CLEAR = 'fulcrum/container/Manage/Nvbugs/NvbugsDialog/CLEAR'

export {
  NVBUGS_DIALOG,
  UPDATE_OTHER_PROJECT,
  UPDATE_OTHER_PROJECT_LIST,
  UPDATE_REC_PROJECT_LIST,
  UPDATE_OPTION_SELECTED,
  UPDATE_NVBUGS_ID,
  FETCH_OTHER_PROJECT_LIST,
  FETCH_OTHER_PROJECT_LIST_START,
  FETCH_OTHER_PROJECT_LIST_SUCCESS,
  FETCH_OTHER_PROJECT_LIST_ERROR,
  POST_NVBUG_PROJECT,
  POST_NVBUG_PROJECT_START,
  POST_NVBUG_PROJECT_SUCCESS,
  POST_NVBUG_PROJECT_ERROR,
  FETCH_REC_PROJECT_LIST,
  FETCH_REC_PROJECT_LIST_START,
  FETCH_REC_PROJECT_LIST_SUCCESS,
  FETCH_REC_PROJECT_LIST_ERROR,
  UPDATE_PAGE,
  FETCH_NVBUG,
  FETCH_NVBUG_START,
  FETCH_NVBUG_SUCCESS,
  FETCH_NVBUG_ERROR,
  CLEAR
}
